import getStore from '../data/store/store';
import datapoints from '../datapoints';
import { logUsage } from 'owa-analytics';
/**
 * Utility function to log the usage of options.
 */
export default function logDataOnSaveAppearance() {
    var currentState = getStore();
    if (!currentState) {
        return;
    }
    logWeekStartDay('WeekStartDay');
    logTimeIncrement();
    logFirstWeekOfYear();
    logWeekNumbers();
    logWorkingHoursStartTime();
    logWorkingHoursEndTime();
    logWorkDay();
}
/**
 * Utility function to log the usage of week start day quick settings.
 */
export function logDataOnSaveWeekStartDayQuickSetting() {
    var currentState = getStore();
    if (!currentState) {
        return;
    }
    logWeekStartDay('WeekStartDayQuick');
}
export function logWeekStartDay(datapointKey) {
    var currentState = getStore();
    if (currentState.weekStartDay != null) {
        var customData = datapoints[datapointKey].datapoint.customData(currentState.weekStartDay);
        logUsage(datapoints[datapointKey].datapoint.name, customData);
    }
}
function logTimeIncrement() {
    var currentState = getStore();
    if (currentState.timeIncrement != null) {
        var customData = datapoints.TimeIncrement.datapoint.customData(currentState.timeIncrement);
        logUsage(datapoints.TimeIncrement.datapoint.name, customData);
    }
}
function logFirstWeekOfYear() {
    var currentState = getStore();
    if (currentState.firstWeekOfYear != null) {
        var customData = datapoints.FirstWeekOfYear.datapoint.customData(currentState.firstWeekOfYear);
        logUsage(datapoints.FirstWeekOfYear.datapoint.name, customData);
    }
}
function logWeekNumbers() {
    var currentState = getStore();
    if (currentState.showWeekNumbers != null) {
        var customData = datapoints.ShowWeekNumbers.datapoint.customData(currentState.showWeekNumbers);
        logUsage(datapoints.ShowWeekNumbers.datapoint.name, customData);
    }
}
function logWorkingHoursStartTime() {
    var currentState = getStore();
    if (currentState.workingHoursStartTime != null) {
        var customData = datapoints.WorkingHoursStartTime.datapoint.customData(currentState.workingHoursStartTime);
        logUsage(datapoints.WorkingHoursStartTime.datapoint.name, customData);
    }
}
function logWorkingHoursEndTime() {
    var currentState = getStore();
    if (currentState.workingHoursEndTime != null) {
        var customData = datapoints.WorkingHoursEndTime.datapoint.customData(currentState.workingHoursEndTime);
        logUsage(datapoints.WorkingHoursEndTime.datapoint.name, customData);
    }
}
function logWorkDay() {
    var currentState = getStore();
    if (currentState.workDays != null) {
        var customData = datapoints.WorkDays.datapoint.customData(currentState.workDays);
        logUsage(datapoints.WorkDays.datapoint.name, customData);
    }
}
//# sourceMappingURL=logDataOnSaveAppearance.js.map